import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'button-novo-search-ait',
  templateUrl: './button-novo-search.component.html',
  styleUrls: ['./button-novo-search.component.scss']
})
export class ButtonNovoSearchComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
